import { dayjs } from '@mobi/utils'

export function getDateLabel(date: string, forceExplicitDate = false): string {
  if (dayjs(date).isToday()) return 'Today'
  if (dayjs(date).isTomorrow()) return 'Tomorrow'
  if (dayjs(date).isYesterday()) return 'Yesterday'

  if (
    forceExplicitDate ||
    dayjs(date).isBefore(dayjs()) ||
    dayjs(date).isAfter(dayjs().add(6, 'day'))
  ) {
    if (dayjs(date).year() !== dayjs().year()) return dayjs(date).format('ddd MMM Do YYYY')
    return dayjs(date).format('ddd MMM Do')
  }

  return dayjs(date).format('dddd')
}
